// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 676 ? "9932c28f" : chunkId) + "." + {"528":"74b2cc68f941d932","676":"d9a6863ea1cc8275"}[chunkId] + ".js";
};